import { Component } from '@angular/core';
import { AlertController,App} from 'ionic-angular';
import { StorageService } from '../../../providers/service/storageservice';
import { LoginPage } from '../../login/login/login';
import { AppState } from '../../../app/app.global';

import { HttpService } from '../../../providers/service/httpservice';
import { SAVE_UPDATE_PWD} from '../../../providers/config/serviceurl';
import { Utils} from '../../../providers/service/utils';
import { ToastController } from 'ionic-angular';

@Component({
  selector: 'set-gesture-page',
  templateUrl: 'setgesture.html'
})
export class SetGesturePage {
	user:any =null;
	gesture1:string;
	gesture2:string;
	showGesture: boolean = StorageService.getObj('showGesture');
	showGesture1: boolean = false;
	showGesture2: boolean = false;
	constructor (private alertCtrl: AlertController,public appCtrl: App,public global: AppState,private httpService:HttpService,public toastCtrl: ToastController) {
		this.user = StorageService.getObj('currentUser');
	}
	toggleGes(){
		if(!this.showGesture){
			StorageService.setObj("showGesture", false);
			this.showGesture2 = false;
		}
		this.showGesture1 = this.showGesture;
	}
	getGesture1(event: any) {
	  this.gesture1 = `${event}`;
	  if(!this.gesture1){
		  return
	  }
	  this.presentToast("请再输一遍");
	  this.showGesture1 = false;
	  this.showGesture2 = true;
	}
	getGesture2(event: any) {
		this.gesture2 = `${event}`;
		if(!this.gesture2){
			return
		}
		if(this.gesture1 == this.gesture2){
			this.presentToast("设置成功");
			StorageService.setObj("showGesture", this.showGesture);
			StorageService.setObj("gesture", this.gesture1);
			this.showGesture2 = false;
		}else {
			this.presentToast("两次输入不一样，请重新输入");
			this.showGesture2 = false;
			this.showGesture1 = true;
		}
	}
	presentToast(message) {
		const toast = this.toastCtrl.create({
			message: message,
			duration: 1000
		});
		toast.present();
	}
}



// WEBPACK FOOTER //
// ./src/pages/about/setgesture/setgesture.ts